module.exports = __webpack_public_path__ + "media/Schamanzs_1920.2a8ba6a2.mp4";